import groundcover from '@groundcover/browser';
import { getEnv } from './env';

export function initTelemetry() {
  const VITE_STAGE = getEnv().VITE_STAGE;
  if (VITE_STAGE && import.meta.env.VITE_GROUNDCOVER_DSN && import.meta.env.VITE_GROUNDCOVER_API_KEY) {
    groundcover.init({
      apiKey: import.meta.env.VITE_GROUNDCOVER_API_KEY,
      dsn: `https://${import.meta.env.VITE_GROUNDCOVER_DSN}`,
      cluster: 'bl-authorization-app',
      environment: VITE_STAGE,
      appId: 'bl-authorization-app-browser',
    });
  }
}
